import { CheckTicketPusatResolusiRequest, GetConversationRequest, ListSTTPusatResolusi, ListTicketPusatResolusiRequest, TicketCounterPusatResolusiRequest, GetTicketActionRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { ApiRequestList } from "@/domain/entities/MainApp";

export class PusatResolusiV2Endpoint {
  checkTicket(params: CheckTicketPusatResolusiRequest): string {
    return `athena/v1/ticket/check?${params.toQueryString()}`;
  }
  checkTicketV2(params: CheckTicketPusatResolusiRequest): string {
    return `athena/v2/ticket/check?${params.toQueryString()}`;
  }
  getListCategory(params: CheckTicketPusatResolusiRequest): string {
    return `athena/v1/category?${params.toQueryString()}`;
  }
  getTicketCounter(params: TicketCounterPusatResolusiRequest): string {
    return `athena/v1/ticket/summary?${params.toQueryString()}`;
  }
  getTicketList(params: ListTicketPusatResolusiRequest): string {
    return `athena/v1/ticket?${params.toQueryString()}`;
  }
  getSTTList(params: ListSTTPusatResolusi): string {
    return `/athena/v1/stt/issue?${params.toQueryString()}`;
  }
  checkIssue(params: CheckTicketPusatResolusiRequest) {
    return `athena/v1/ticket/check?${params.toQueryString()}`;
  }
  checkIssueV2(params: CheckTicketPusatResolusiRequest) {
    return `athena/v2/ticket/check?${params.toQueryString()}`;
  }
  followTicket(id: number) {
    return `/athena/v1/ticket/${id}/follow`;
  }
  getTicketDetail(id: number) {
    return `/athena/v1/ticket/${id}`;
  }
  getTicketAction(id: number, params: GetTicketActionRequest): string {
    return `/athena/v1/ticket/${id}/action?${params.toQueryString()}`;
  }
  submitNote(id: number) {
    return `/athena/v1/ticket/${id}/note`;
  }
  create(): string {
    return "athena/v1/ticket";
  }
  finishIssue(id: number) {
    return `/athena/v1/ticket/${id}/finish`;
  }
  reopenIssue(id: number) {
    return `/athena/v1/ticket/${id}/reopen`;
  }
  getConversation(id: number, params: GetConversationRequest): string {
    return `/athena/v1/ticket/${id}/conversation?${params.toQueryString()}`;
  }
  getMention(id: number) {
    return `/athena/v1/ticket/${id}/mention`;
  }
  sendChat(id: number) {
    return `/athena/v1/ticket/${id}/conversation`;
  }
  feedback(id: number) {
    return `/athena/v1/ticket/${id}/feedback`;
  }
  templateChat() {
    return "/athena/v1/ticket/conversation/template";
  }
  addTemplate() {
    return "/athena/v1/ticket/conversation/template";
  }
  requestDownloadLaporan() {
    return "athena/v1/bulk-download/list-ticket";
  }
  getBulkDownload(params: ApiRequestList): string {
    return `athena/v1/bulk-download?${params.toQueryString()}`;
  }
  checkCategory() {
    return `athena/v1/category/check`;
  }
}
